import React from 'react';
import { ChevronDown } from 'lucide-react';
import cenevreBg from '../img/cenevre-hero.jpg';
import gwsLogo from '../img/gws-logo.png';
import gun1Img from '../img/cenevre-gun1-ap-muzesi.jpg';
import gun3Img from '../img/cenevre-gun3-cern.png';
import gun4Img from '../img/cenevre-gun4-havaalani.jpg';

const CenevreLandingEn = () => {

  return (
    <div className="relative w-full overflow-x-hidden">
      {/* Navbar */}
      <nav className="absolute top-0 left-0 right-0 z-50 py-6">
        <div className="max-w-[1920px] mx-auto px-8 lg:px-16">
          <div className="flex items-center justify-center">
            <div className="flex flex-col items-center group cursor-default">
              <div
                className="h-12 w-12 group-hover:scale-110 transition-transform duration-500"
                style={{
                  backgroundColor: '#1a441f',
                  WebkitMaskImage: `url(${gwsLogo})`,
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  maskImage: `url(${gwsLogo})`,
                  maskRepeat: 'no-repeat',
                  maskSize: 'contain',
                  maskPosition: 'center',
                }}
              />
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={cenevreBg}
            alt="Geneva"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#587c8d]/70 via-[#587c8d]/50 to-[#587c8d]/90" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#587c8d]/30 to-transparent" />
        </div>

        <div className="relative z-10 flex flex-col justify-center items-center h-full w-full px-8 text-center">
          <div className="max-w-4xl">
            <p className="text-white text-sm lg:text-base font-medium tracking-widest uppercase mb-4 drop-shadow-md">
              Geneva
            </p>
            <h1 className="text-[#f8f8f8] text-5xl lg:text-8xl font-bold leading-tight mb-6 drop-shadow-lg" style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}>
              A Collector's Dream: Audemars Piguet & Patek Philippe
            </h1>
            <div className="text-[#f8f8f8] text-2xl lg:text-3xl font-bold mb-8 drop-shadow-md">
              June 4–7, 2026
            </div>
          </div>
        </div>

        <div className="absolute bottom-24 left-0 right-0 z-10 px-8 text-center flex justify-center">
          <p className="text-[#1a441f] text-base lg:text-xl font-medium leading-relaxed max-w-2xl drop-shadow-md">
            Hosted by Xavier Bonna, we experience Geneva—from the heart of haute horlogerie to the timepieces passed down through generations.
          </p>
        </div>

        <div
          onClick={() => document.getElementById('program')?.scrollIntoView({ behavior: 'smooth' })}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 cursor-pointer animate-bounce group"
        >
          <ChevronDown className="w-8 h-8 text-white/60 group-hover:text-white/90 transition-colors" />
        </div>
      </section>

      {/* Program Section */}
      <section id="program" className="bg-[#f9fafb] pt-10 lg:pt-16 pb-9 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.08] pointer-events-none grayscale"
          style={{
            backgroundImage: `url("https://customer-assets.emergentagent.com/job_wealth-legacy-2/artifacts/vulhojge_gws.png")`,
            backgroundSize: '120px',
            backgroundRepeat: 'space'
          }}
        />

        <div className="max-w-[1920px] mx-auto px-8 lg:px-16 relative z-10">
          <div className="flex flex-col gap-16 lg:gap-24">

            {/* Day 1 */}
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 items-center">
              <div className="w-full lg:w-1/2">
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-2xl">
                  <img
                    src={gun1Img}
                    alt="Musée Atelier Audemars Piguet"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>

              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 rounded-full bg-[#1a441f] flex items-center justify-center text-[#e4a483] font-bold text-xl shrink-0">1</div>
                  <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold" style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}>
                    Arrival & Vallée de Joux
                  </h3>
                </div>

                <div className="mb-8">
                  <span className="text-[#587c8d] font-medium tracking-widest text-sm uppercase">Thursday, June 4</span>
                </div>

                <ul className="space-y-4 text-[#587c8d] font-medium leading-relaxed list-none p-0 m-0">
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">05:30 —</span> Meet at Istanbul Airport for Turkish Airlines TK1917 flight departing at 06:55.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">10:30 —</span> Departure from hotel to Vallée de Joux.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">12:00 —</span> Lunch at Hôtel des Horlogers.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">14:00 —</span> Musée Atelier Audemars Piguet tour and private shopping experience.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">16:30 —</span> Return to our hotel in Geneva.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">19:00 —</span> Dinner first night at Port-Gitana in Bellevue by the lake.
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 2 */}
            <div className="flex flex-col lg:flex-row-reverse gap-12 lg:gap-24 items-center">
              <div className="w-full lg:w-1/2">
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-2xl">
                  <img
                    src="https://travel.usnews.com/dims4/USNEWS/b9530b3/2147483647/resize/1200x630%3E/quality/85/format/webp/?url=https%3A%2F%2Ftravel.usnews.com%2Fimages%2FPatek_Philippe_Museum_ACinjfd.jpg"
                    alt="Patek Philippe Museum"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>

              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 rounded-full bg-[#1a441f] flex items-center justify-center text-[#e4a483] font-bold text-xl shrink-0">2</div>
                  <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold" style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}>
                    Lombard Odier & Patek Philippe
                  </h3>
                </div>

                <div className="mb-8">
                  <span className="text-[#587c8d] font-medium tracking-widest text-sm uppercase">Friday, June 5</span>
                </div>

                <ul className="space-y-4 text-[#587c8d] font-medium leading-relaxed list-none p-0 m-0">
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">09:30 —</span> Departure from hotel to visit Lombard Odier bank.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">12:30 —</span> Lunch with Xavier Bonna, 6th Generation of the Family.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">14:30 —</span> Patek Philippe Museum Private Visit.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">18:30 —</span> Departure from hotel to visit old town.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">20:00 —</span> Traditional Swiss fondue at Les Armures.
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 3 */}
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 items-center">
              <div className="w-full lg:w-1/2">
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-2xl">
                  <img
                    src={gun3Img}
                    alt="CERN Science Gateway"
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>

              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 rounded-full bg-[#1a441f] flex items-center justify-center text-[#e4a483] font-bold text-xl shrink-0">3</div>
                  <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold" style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}>
                    CERN & Vineyard Visit
                  </h3>
                </div>

                <div className="mb-8">
                  <span className="text-[#587c8d] font-medium tracking-widest text-sm uppercase">Saturday, June 6</span>
                </div>

                <ul className="space-y-4 text-[#587c8d] font-medium leading-relaxed list-none p-0 m-0">
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">09:00 —</span> Departure from hotel for guided tour at CERN.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">11:30 —</span> Departure from Cern to have lunch at Auberge de Fechy.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">14:00 —</span> Wine tasting at Domaine de La Colombe with 2nd generation Laura Paccot whose family owns the vineyard.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">17:00 —</span> Return to city center & Free evening.
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 4 */}
            <div className="flex flex-col lg:flex-row-reverse gap-12 lg:gap-24 items-center">
              <div className="w-full lg:w-1/2">
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-2xl">
                  <img
                    src={gun4Img}
                    alt="Geneva Airport"
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>

              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 rounded-full bg-[#1a441f] flex items-center justify-center text-[#e4a483] font-bold text-xl shrink-0">4</div>
                  <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold" style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}>
                    Free Morning & Departure
                  </h3>
                </div>

                <div className="mb-8">
                  <span className="text-[#587c8d] font-medium tracking-widest text-sm uppercase">Sunday, June 7</span>
                </div>

                <ul className="space-y-4 text-[#587c8d] font-medium leading-relaxed list-none p-0 m-0">
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">09:00 —</span> Free morning. No agenda. Parc de la Grange rose garden, MAH Museum, lakeside breakfast, or simply a slow morning at the hotel.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">13:00 —</span> Transfer to Geneva Airport.
                  </li>
                  <li className="block">
                    <span className="font-bold text-lg text-[#1a441f]">14:50 —</span> Departure to Istanbul (Turkish Airlines). Arrival ~19:00.
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative w-full overflow-hidden bg-white">
        <div className="absolute inset-0 bg-[#587c8d]/60" />
        <div className="relative z-10 px-8 lg:px-16 py-6 text-center text-white">
          <p className="leading-relaxed mb-6" style={{ color: 'rgb(88, 124, 141)', textShadow: '0 0 0.6px currentColor, 0 0 0.6px currentColor' }}>
            This programme has been specially prepared for GWS members. For detailed information about the experience, contact GWS via WhatsApp.
          </p>
          <div>
            <h3 className="text-lg font-bold mb-2 text-white" style={{ fontFamily: "'Spirits Soft', 'Figtree', sans-serif" }}>Cancellation Policy</h3>
            <ul className="leading-relaxed text-white">
              <li>Cancellations made more than 2 weeks before departure are eligible for a full refund.</li>
              <li>Cancellations made less than 2 weeks before departure are non-refundable.</li>
              <li>Refunds will be processed to the original payment method within 5–10 business days.</li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CenevreLandingEn;
